<app-details-table-header (doSearch)="doSearch($event)"></app-details-table-header>
<ng-container [ngTemplateOutlet]="body" [ngTemplateOutletContext]="{searchTerm: searchTerm}"></ng-container>
